require.register("documenteditor/controllers/fieldEntryArchivnrCtrl", function(exports, require, module){
  $0
  
});

